mutation RemoveCampaign($campaignId: ID!) {
    removeCampaign(campaignId: $campaignId)
}
